
  import { defineComponent } from 'vue';
  import { Message } from '@/ui/components/message/Message';

  interface ConductInspectionHideFormInformationProps {
    message: string;
  }

  export default defineComponent<ConductInspectionHideFormInformationProps>({
    components: { Message },
    props: ['message']
  });
